import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SwiperCore, { Navigation, HashNavigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { AnalyticsContext } from '@/v2/components/application/Analytics';
import { IsIPadSafari } from '@/v2/components/utils/DeviceUtils';

import Loading from '@/v2/components/atoms/Loading';
import Slide, { withBackgroundImage } from '@/v2/components/layouts/Slide';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

import './CarouselSlider.scss';

SwiperCore.use([Navigation, HashNavigation, A11y]);

const SlideWithBackgroundImage = withBackgroundImage(Slide);

const SLIDES = [
    {
        title: 'connectivity',
        image: 'Connectivity',
        route: 'connectivity',
    },
    {
        title: 'design',
        image: 'Design',
        route: 'design',
    },
    {
        title: 'performance',
        image: 'Performance',
        route: 'performance',
    },
    {
        title: 'driver-assist',
        image: 'Drivers_Assist',
        route: 'driverAssist',
    },
];

const propTypes = {
    loop: PropTypes.bool,
    slides: PropTypes.array,
    speed: PropTypes.number,
};

const defaultProps = {
    loop: false,
    slides: null,
    speed: 500,
};

const isIPadSafari = IsIPadSafari();

const CarouselSliderComponent = ({ loop, slides, speed }) => {
    const location = useLocation();
    const history = useHistory();
    const { trackEvent } = useContext(AnalyticsContext);

    const [safariIPad, setSafariIPad] = useState(false);

    let isMounted = false;
    const slideIndex = location.hash ? SLIDES.findIndex((slide) => location.hash.slice(1) === slide.route) : 0;

    useEffect(() => {
        isMounted = true;
        if (!location.hash) {
            history.push('#connectivity');
        }
    }, []);

    const onResizeHandler = () => {
        if (isIPadSafari) {
            setSafariIPad(window.innerWidth < 1000);
        }
    };

    const onSlideChange = ({ realIndex }) => {
        if (isMounted) {
            trackEvent('carouselInteraction', {
                itemNumber: `${realIndex + 1}/${SLIDES.length}`,
                promoText: SLIDES[realIndex].title,
                carouselType: 'Normal',
                interactionType: 'Virtual car menu',
            });
        }
    };

    const carouselClasses = classNames({
        CarouselSlider: true,
        'safari-ipad': safariIPad,
    });

    return (
        <section className={carouselClasses}>
            <Swiper
                centeredSlides
                hashNavigation
                initialSlide={slideIndex}
                loop={loop}
                navigation
                onResize={onResizeHandler}
                onSlideChange={onSlideChange}
                slidesPerView={safariIPad ? 1.00001 : 1.666}
                speed={speed}
                tag="section"
                wrapperTag="ul"
            >
                {slides.map((data, index) => (
                    <SwiperSlide tag="li" key={data.route} data-hash={SLIDES[index].route}>
                        <SlideWithBackgroundImage className={SLIDES[index].title} data={data} image={SLIDES[index].image} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

CarouselSliderComponent.propTypes = propTypes;
CarouselSliderComponent.defaultProps = defaultProps;

const CarouselSlider = ({ loop, slides, speed }) => (slides ? <CarouselSliderComponent loop={loop} slides={slides} speed={speed} /> : <Loading />);

export default CarouselSlider;
